var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.submit)?_c('adm-button',{staticClass:"next-step",attrs:{"id":"btn_next_submit","data-cy":"submit"}},[_vm._v(" "+_vm._s(_vm.submit)+" ")]):_c('adm-icon-button',{staticClass:"next-step",attrs:{"round":"","id":_vm.btnId || 'btn_next_submit',"data-cy":"submit","icon":"arrow_forward_24px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }